import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AngularEditorConfigService } from 'gung-common';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { DynamicPageElement } from '../../../services/dynamic-pages/dynamic-pages.service';
import { GungFlowService } from '../../../../../services/gung-flow/gung-flow.service';
import { GungFlow } from '../../../../../state/flow/types';

@Component({
  selector: 'lib-dynamic-page-dc-base',
  standalone: false,
  templateUrl: './dynamic-page-dc-base.component.html',
  styleUrl: './dynamic-page-dc-base.component.scss'
})
export class DynamicPageDcBaseComponent implements OnInit, OnDestroy {

  protected angularEditorConfigService = inject(AngularEditorConfigService);
  protected router = inject(Router);
  protected gungFlowService = inject(GungFlowService);

  protected unsubscribe = new Subject<void>();
  protected currentFlowId: GungFlow | undefined;

  @Input()
  mode = 'renderer';

  @Input()
  edit = false;

  @Input() element!: DynamicPageElement;

  @Output() selectComponent = new EventEmitter<boolean>();

  elementId: string;

  fields: { [s: string]: any };

  angularEditorConfig: AngularEditorConfig = {
    ...this.angularEditorConfigService.getDefaultEditorConfig(),
    toolbarHiddenButtons: [
      ['fontSize','undo','redo']
    ]
  }

  ngOnInit(): void {
    if (!this.element) {
      this.element = { id: this.elementId, fields: {} };
    }
    if (Object.keys(this.element.fields).length === 0) {
      this.element.fields = this.fields;
    }
    this.gungFlowService
      .getSelectedFlow()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(flow => {
        this.currentFlowId = flow;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  btnClick(event: MouseEvent | null, url: string) {
    if (!this.edit) {
      if (!url) return;

      if (url.includes('flowid=')) {
        this.navigateWithFlow(url);
        return;
      }

      if (url.startsWith('http')) {
        window.open(url, '_blank');
      } else if (url.startsWith('/')) {
        this.router.navigateByUrl(url);
      } else {
        this.router.navigate([url]);
      }
    }
  }

  navigateWithFlow(linkUrlWithFlowId: string) {
    const url = new URL('http://localhost' + linkUrlWithFlowId);
    const urlParams = new URLSearchParams(url.search);
    const flowid = urlParams.get('flowid');
    urlParams.delete('flowid');
    const newUrl = urlParams.toString().length > 0 ? url.pathname + '?' + urlParams.toString() : url.pathname;
    if (flowid && this.currentFlowId?.id !== flowid) {
      this.gungFlowService
        .getSelectedFlow()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(flow => {
          if (flow.id === flowid) {
            if ((urlParams as any)?.size > 0) {
              const params = Object.fromEntries((urlParams as any).entries());
              this.router.navigate(url.pathname.split('/').filter(p => p !== ''), { queryParams: params });
            } else {
              this.router.navigateByUrl(newUrl);
            }
          }
        });
      this.gungFlowService.selectFlow(flowid);
      return;
    }
    this.router.navigateByUrl(newUrl);
  }
}
